(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grid-banner-with-product"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  $(".video__btn-play").on("click", function (e) {
    e.preventDefault();
    $('body').addClass('overlay-active');
    $(".video-popup").css('display','flex');
    var srchref = "",
        autoplay = "",
        id = $(this).data("id");
    if ($(this).data("type") == "vimeo")
      var srchref = "//player.vimeo.com/video/";
    else if ($(this).data("type") == "youtube")
      var srchref = "https://www.youtube.com/embed/";
    if ($(this).data("autoplay") == true) autoplay = "?autoplay=1";
    $("#video-popup-iframe").attr("src", srchref + id + autoplay);
    $("#video-popup-iframe").on("load", function () {
      $(".video-wrapper").show();
    });
  });

  $(".pop-up__video-close , .video-popup").on("click", function (e) {
     $('body').removeClass('overlay-active');
    $(".video-container,.video-wrapper,.pop-up__video-close ,.video-popup").css('display','none');
    $("#video-popup-iframe").attr("src", "");
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const installProductTapOpenFix = (swiperEl, swiper) => {
      if (!swiperEl || swiperEl.dataset.tsProductTapReady) {
        return;
      }

      swiperEl.dataset.tsProductTapReady = '1';

      let startX = 0;
      let startY = 0;
      let startTime = 0;
      let startTarget = null;
      let moved = false;
      let lastOpenedAt = 0;

      const TAP_MOVE_LIMIT = 9;
      const TAP_TIME_LIMIT = 650;

      const isMobile = () => window.innerWidth < 750;

      const isIgnoredTarget = (target) => {
        return !!(
          target &&
          target.closest &&
          target.closest(
            'button, input, select, textarea, label, summary, details, ' +
            '.quick-add, .quick-add__submit, .card__buttons, .card__button, ' +
            '.product-card__buttons, .product-icons, .card-icons, ' +
            '.quick-view, .button--quick-view, .wishlist, .compare'
          )
        );
      };

      const getProductUrl = (target) => {
        if (!target || !target.closest) {
          return '';
        }

        const directLink = target.closest('a[href]');
        if (
          directLink &&
          directLink.getAttribute('href') &&
          directLink.getAttribute('href').charAt(0) !== '#'
        ) {
          return directLink.href;
        }

        const card = target.closest(
          '.swiper-slide, .card-wrapper, .card, .product-card'
        );

        if (!card) {
          return '';
        }

        const selectors = [
          'a.full-unstyled-link[href]',
          '.card__heading a[href]',
          '.card-information__text a[href]',
          '.product-title a[href]',
          'a[href*="/products/"]'
        ];

        for (let i = 0; i < selectors.length; i += 1) {
          const link = card.querySelector(selectors[i]);

          if (
            link &&
            link.getAttribute('href') &&
            link.getAttribute('href').charAt(0) !== '#'
          ) {
            return link.href;
          }
        }

        return '';
      };

      const openProduct = (url) => {
        if (!url) {
          return;
        }

        lastOpenedAt = Date.now();

        if (swiper && typeof swiper.allowClick !== 'undefined') {
          swiper.allowClick = true;
        }

        window.location.assign(url);
      };

      swiperEl.addEventListener(
        'touchstart',
        (event) => {
          if (!isMobile()) {
            return;
          }

          const touch = event.touches && event.touches[0];

          if (!touch || isIgnoredTarget(event.target)) {
            return;
          }

          startX = touch.clientX;
          startY = touch.clientY;
          startTime = Date.now();
          startTarget = event.target;
          moved = false;
        },
        { passive: true, capture: true }
      );

      swiperEl.addEventListener(
        'touchmove',
        (event) => {
          if (!isMobile()) {
            return;
          }

          const touch = event.touches && event.touches[0];

          if (!touch || !startTarget) {
            return;
          }

          const diffX = Math.abs(touch.clientX - startX);
          const diffY = Math.abs(touch.clientY - startY);

          if (diffX > TAP_MOVE_LIMIT || diffY > TAP_MOVE_LIMIT) {
            moved = true;
          }
        },
        { passive: true, capture: true }
      );

      swiperEl.addEventListener(
        'touchend',
        (event) => {
          if (!isMobile() || !startTarget) {
            return;
          }

          const changedTouch = event.changedTouches && event.changedTouches[0];

          if (!changedTouch) {
            startTarget = null;
            return;
          }

          const diffX = Math.abs(changedTouch.clientX - startX);
          const diffY = Math.abs(changedTouch.clientY - startY);
          const duration = Date.now() - startTime;

          const isRealTap =
            !moved &&
            diffX <= TAP_MOVE_LIMIT &&
            diffY <= TAP_MOVE_LIMIT &&
            duration <= TAP_TIME_LIMIT;

          const url = getProductUrl(startTarget);

          startTarget = null;

          if (!isRealTap || !url) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          openProduct(url);
        },
        { passive: false, capture: true }
      );

      swiperEl.addEventListener(
        'click',
        (event) => {
          if (!isMobile()) {
            return;
          }

          if (Date.now() - lastOpenedAt < 900) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }

          if (isIgnoredTarget(event.target)) {
            return;
          }

          const clickedImageArea = event.target.closest(
            '.card__media, .media, .card__media img, .media img'
          );

          if (!clickedImageArea) {
            return;
          }

          const url = getProductUrl(event.target);

          if (!url) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          openProduct(url);
        },
        true
      );
    };

    const fixRecommendationSlider = (root) => {
      const swipers = root.querySelectorAll('.swiper');

      swipers.forEach((swiperEl) => {
        const applyFix = () => {
          const swiper = swiperEl.swiper;

          if (!swiper) {
            return;
          }

          if (swiper.loopDestroy && swiper.params && swiper.params.loop) {
            swiper.loopDestroy();
          }

          swiperEl.querySelectorAll('.swiper-slide-blank').forEach((slide) => {
            slide.remove();
          });

          if (swiper.params) {
            swiper.params.loop = false;
            swiper.params.rewind = false;
            swiper.params.centeredSlides = false;
            swiper.params.centerInsufficientSlides = false;
            swiper.params.slidesPerGroup = 1;
            swiper.params.slidesOffsetBefore = 0;
            swiper.params.slidesOffsetAfter = 0;
            swiper.params.loopFillGroupWithBlank = false;

            swiper.params.preventClicks = false;
            swiper.params.preventClicksPropagation = false;
            swiper.params.touchStartPreventDefault = false;
            swiper.params.touchMoveStopPropagation = false;
            swiper.params.threshold = 8;

            if (window.innerWidth < 750) {
              swiper.params.slidesPerView = 2;
              swiper.params.spaceBetween = 0;
            }

            if (swiper.params.breakpoints) {
              Object.keys(swiper.params.breakpoints).forEach((key) => {
                if (!swiper.params.breakpoints[key]) {
                  return;
                }

                swiper.params.breakpoints[key].loop = false;
                swiper.params.breakpoints[key].rewind = false;
                swiper.params.breakpoints[key].centeredSlides = false;
                swiper.params.breakpoints[key].centerInsufficientSlides = false;
                swiper.params.breakpoints[key].slidesPerGroup = 1;
                swiper.params.breakpoints[key].slidesOffsetBefore = 0;
                swiper.params.breakpoints[key].slidesOffsetAfter = 0;
                swiper.params.breakpoints[key].loopFillGroupWithBlank = false;

                swiper.params.breakpoints[key].preventClicks = false;
                swiper.params.breakpoints[key].preventClicksPropagation = false;
                swiper.params.breakpoints[key].touchStartPreventDefault = false;
                swiper.params.breakpoints[key].touchMoveStopPropagation = false;
                swiper.params.breakpoints[key].threshold = 8;

                if (Number(key) < 750) {
                  swiper.params.breakpoints[key].slidesPerView = 2;
                  swiper.params.breakpoints[key].spaceBetween = 0;
                }
              });
            }
          }

          swiper.update();

          installProductTapOpenFix(swiperEl, swiper);

          const clampSlider = () => {
            const slides = swiperEl.querySelectorAll(
              '.swiper-slide:not(.swiper-slide-duplicate):not(.swiper-slide-blank)'
            );

            const visible =
              window.innerWidth < 750
                ? 2
                : Number(swiper.params.slidesPerView) || 1;

            const maxIndex = Math.max(0, slides.length - visible);

            if (swiper.activeIndex > maxIndex) {
              swiper.slideTo(maxIndex, 0, false);
            }
          };

          clampSlider();

          if (!swiperEl.dataset.tsClampReady) {
            swiperEl.dataset.tsClampReady = '1';

            swiper.on('slideChangeTransitionEnd', clampSlider);

            swiper.on('touchEnd', () => {
              setTimeout(clampSlider, 60);
            });

            window.addEventListener('resize', () => {
              swiper.update();
              clampSlider();
            });
          }
        };

        let attempts = 0;

        const timer = setInterval(() => {
          attempts += 1;
          applyFix();

          if (swiperEl.swiper || attempts >= 25) {
            clearInterval(timer);
          }
        }, 80);
      });
    };

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            if (window.jQuery) {
              window.jQuery('.loading-image').removeClass('loading-image').addClass('loaded-image');
            } else {
              document.querySelectorAll('.loading-image').forEach((item) => {
                item.classList.remove('loading-image');
                item.classList.add('loaded-image');
              });
            }

            setTimeout(() => fixRecommendationSlider(this), 100);
            setTimeout(() => fixRecommendationSlider(this), 500);
            setTimeout(() => fixRecommendationSlider(this), 1200);
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px'
    }).observe(this);
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

  } catch(e) { console.error(e); }
})();
})();
